// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"vJ-z","smallCardRow":"wJ-z","largeCardRow":"xJ-z","productSearchRow":"yJ-z","curatedRow":"zJ-z"};